import { IntegrationWorkspace } from '@ardoq/api-types/integrations';
import { WithPopover } from '@ardoq/popovers';
import { FlexBox } from '@ardoq/layout';
import { Icon, IconName } from '@ardoq/icons';
import { colors } from '@ardoq/design-tokens';
import { Link } from '@ardoq/link';
import styled from 'styled-components';
import { type I18nLocale, t } from '@ardoq/i18n';

type WorkspaceNameProps = {
  isWorkspaceAvailable: boolean;
  workspace: IntegrationWorkspace;
  onWorkspaceClick?: ((workspace: IntegrationWorkspace) => void) | null;
  i18nLocale: I18nLocale;
};

const WorkspaceNotAvailable = styled(FlexBox)`
  width: fit-content;
`;

export const WorkspaceName = ({
  isWorkspaceAvailable,
  workspace,
  onWorkspaceClick,
  i18nLocale,
}: WorkspaceNameProps) => {
  if (!isWorkspaceAvailable) {
    return (
      <WithPopover
        content={t(
          i18nLocale,
          'integrations:workspaceName.notAvailable',
          'Workspace is not available'
        )}
      >
        <WorkspaceNotAvailable align="center" gap="xxsmall">
          {workspace.name}
          <Icon iconName={IconName.INFO} color={colors.grey500} />
        </WorkspaceNotAvailable>
      </WithPopover>
    );
  }

  return onWorkspaceClick ? (
    <Link
      iconName={IconName.WORKSPACE}
      type="primary"
      typography="text1"
      onClick={() => onWorkspaceClick(workspace)}
    >
      {workspace.name}
    </Link>
  ) : (
    workspace.name
  );
};
